import axios from "axios";
import jwt_decode from "jwt-decode";
import router from '../../router/index';

var config = {
    headers: {
        Authorization: 'Bearer ' + localStorage.getItem("jwt")
    }
}
export const UserDetails = {
    namespaced: true,
    state: {
        user: [],
        branch: [],
        company: [],
        changedProfilePic: false,
        currentUpdatedProfile: '',
        changedFirstname: false,
        currentUpdatedFirstname: '',
        changedLastname: false,
        currentUpdatedLastname: '', 
    },
    mutations: {
        set_UserDetails(state:any, user:any) {
            state.user = user;
        },
        set_branchDetails(state:any, branch:any) {
            state.branch = branch;
        },
        set_companyDetails(state:any, company:any) {
            state.company = company;
        },
        updateUserData(state: any, data: any) {
            
            state.user.firstname = data.Firstname;
            state.user.lastname = data.Lastname;
            state.user.gender = data.gender;
            state.user.location = data.location;
            state.user.age = data.age;

            state.changedFirstname = true;
            state.changedLastname = true;

            state.currentUpdatedFirstname = data.Firstname;
            state.currentUpdatedLastname = data.Lastname;

            state.user.firstname = state.currentUpdatedFirstname;
            state.user.lastname = state.currentUpdatedLastname;

        },
        updateProfilePicture(state: any, url: any) {
            state.changedProfilePic = true;
            state.currentUpdatedProfile = url;
            state.user.photo = state.currentUpdatedProfile;
        }
        
    },
    
    actions: {
        getUser(context:any, user:any) {
            var token:any = localStorage.getItem("jwt");
            if (!token || token == undefined || token == null) {
                router.push('/welcome');
                return;
            }
            var decoded:any = jwt_decode(token); 
            var userId:any = decoded.id;    
            let url = `https://bookinga.herokuapp.com/api/v1/client/getClient/${userId}`;
            
            axios.get(url, config)
                .then(response => {                    
                    context.commit('set_UserDetails', response.data.data[0]);
                }).catch((err) => {})
        },
        getbranch(context:any, branch:any) {
            let url = `https://bookinga.herokuapp.com/api/v1/company/branch-by-shaloi`;
            
            axios.get(url, config)
                .then(response => {
                    context.commit('set_branchDetails', response.data.data[0]);
                }).catch((err) => {})
        },
        getCompany(context:any, company:any) {
            let url = `https://bookinga.herokuapp.com/api/v1/company/one`;
            
            axios.get(url, config)
                .then(response => {
                    context.commit('set_companyDetails', response.data.message[0]);
                    localStorage.setItem("companyId",response.data.message[0].id)
                    localStorage.setItem("companyName",response.data.message[0].companyname);
                }).catch((err) => {})
        }

    },
    getters: {}
}
